/* Southern Lumen - custom select
   Progressively enhances every native <select> into a styled dropdown that
   matches the dark site (the browser renders a native <option> list that CSS
   cannot touch, so we build our own). The native <select> stays in the DOM as
   the value holder, so the collection sort and every form still submit and fire
   change exactly as before. If enhance() ever throws, the native select is left
   visible and working - the hide only applies once the wrapper is marked ready. */
(function () {
  function enhance(sel) {
    if (sel.multiple || sel.dataset.slEnh || sel.closest('noscript')) return;
    if (!sel.options || sel.options.length === 0) return;
    sel.dataset.slEnh = '1';

    var wrap = document.createElement('div');
    wrap.className = 'sl-cselect';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sl-cselect__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var lbl = document.createElement('span');
    lbl.className = 'sl-cselect__label';
    btn.appendChild(lbl);
    btn.insertAdjacentHTML('beforeend',
      '<svg class="sl-cselect__chev" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>');
    wrap.appendChild(btn);

    var labelText = '';
    if (sel.id) { var l = document.querySelector('label[for="' + sel.id + '"]'); if (l) labelText = l.textContent.trim(); }
    if (!labelText && sel.getAttribute('aria-label')) labelText = sel.getAttribute('aria-label');
    if (labelText) btn.setAttribute('aria-label', labelText);

    var panel = document.createElement('ul');
    panel.className = 'sl-cselect__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    [].forEach.call(sel.options, function (o, i) {
      var li = document.createElement('li');
      li.className = 'sl-cselect__opt';
      li.setAttribute('role', 'option');
      li.textContent = o.textContent;
      li.dataset.index = i;
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      panel.appendChild(li);
    });
    wrap.appendChild(panel);

    function syncLabel() {
      var o = sel.options[sel.selectedIndex];
      lbl.textContent = o ? o.textContent : '';
      [].forEach.call(panel.children, function (li) {
        li.setAttribute('aria-selected', String(+li.dataset.index === sel.selectedIndex));
      });
    }
    function open() {
      if (!panel.hidden) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      var cur = panel.children[sel.selectedIndex];
      if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
      setTimeout(function () { document.addEventListener('click', outside, true); }, 0);
    }
    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      document.removeEventListener('click', outside, true);
    }
    function outside(e) { if (!wrap.contains(e.target)) close(); }
    function pick(i) {
      var o = sel.options[i];
      if (!o || o.disabled) return;
      var changed = i !== sel.selectedIndex;
      sel.selectedIndex = i;
      syncLabel();
      close();
      btn.focus();
      if (changed) {
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    panel.addEventListener('click', function (e) {
      var li = e.target.closest('.sl-cselect__opt');
      if (li && !li.hasAttribute('aria-disabled')) pick(+li.dataset.index);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var d = e.key === 'ArrowDown' ? 1 : -1, ni = sel.selectedIndex;
        do { ni += d; } while (ni >= 0 && ni < sel.options.length && sel.options[ni].disabled);
        if (ni >= 0 && ni < sel.options.length) pick(ni);
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); panel.hidden ? open() : close();
      } else if (e.key === 'Escape') { close(); }
    });
    // If some other script changes the native select, mirror it.
    sel.addEventListener('change', function () { if (document.activeElement !== btn) syncLabel(); });

    syncLabel();
    wrap.classList.add('sl-cselect--ready');
  }

  function init() { [].forEach.call(document.querySelectorAll('select'), function (s) { try { enhance(s); } catch (e) {} }); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  // Collections/other scripts can re-scan after injecting selects.
  document.addEventListener('sl-enhance-selects', init);
})();
